import { Endpoint } from "../config";

export type AuditEndpointType =
  | "auditLogs"
  | "userActivity"
  | "systemLogs";

export const auditEndpoints: Record<AuditEndpointType, Endpoint> = {
  auditLogs: {
    url: "audit-logs/",
  },
  userActivity: {
    url: "audit-logs/user-activity/",
  },
  systemLogs: {
    url: "audit-logs/system-logs/",
  },
};